"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishScene = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const inversify_2 = require("inversify");
const FinishLayer_1 = require("../Layers/FinishLayer");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const ReadyScene_1 = require("./ReadyScene");
const SceneSwitcher_1 = require("./SceneSwitcher");
let FinishScene = class FinishScene extends pixi_js_1.Container {
    constructor(ioc, events, swicher) {
        super();
        const layer = ioc.resolve(FinishLayer_1.FinishLayer);
        layer.onBack = () => {
            events.End.emit();
        };
        layer.onRetry = () => {
            const ready = ioc.resolve(ReadyScene_1.ReadyScene);
            swicher.switch(this, ready).outEnd.add(remove => {
                this.destroy({ children: true });
                return remove();
            });
        };
        this.addChild(layer);
    }
};
FinishScene = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [inversify_2.Container, SymbolClasses_1.GlobalEvents, SceneSwitcher_1.SceneSwitcher])
], FinishScene);
exports.FinishScene = FinishScene;
//# sourceMappingURL=FinishScene.js.map